import http from '../../http'

class PreventionControlVerificationAPI {

  async getAllMeasures(companyID) {
    const response = await http(`prevention_control/all/company/${companyID}`)
    return response || null
  }

  async upsert(payload) {
    const response = await http(`prevention_control_verification/upsert`, 'POST', payload)
    return response
  }

}

export default new PreventionControlVerificationAPI()
